import { IFetchCustomerCardsDTO } from 'modules/customer/domain/dtos';
import { ICustomerCardsRepository } from 'modules/customer/domain/repositories';

export class FetchCustomerCardsUseCase {
  constructor(private customerCardsRepository: ICustomerCardsRepository) {}

  public async execute({
    customerId,
    unitId,
    contractId,
  }: IFetchCustomerCardsDTO) {
    return this.customerCardsRepository.findAll({
      customerId,
      unitId,
      contractId,
    });
  }
}
